import { computeRadii, ingest, loadSrcFromPipeline, pointCount } from "./core.mjs";
import { outlineFromSrc } from "./getStrokeOutlinePoints.mjs";
function getStroke(points, options = {}) {
  ingest(points, options);
  if (pointCount === 0) return [];
  computeRadii(options);
  loadSrcFromPipeline();
  return outlineFromSrc(options);
}
export {
  getStroke
};
//# sourceMappingURL=getStroke.mjs.map
